import { Avatar, Box, Button, IconButton, Input, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CustomAlert from "../../events/components/CustomAlert"
import { updateReviewState } from "../../../redux/reviewSlice";
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import edit from '../../../assets/editExtendIcon.svg'
import { updateCreationState } from "../../../redux/eventCreationSlice";
import { afterValidate, getInitials, setInput, timeStampToDateString, timeStampToDayString, timeStampToNumberedDateString } from "../../../utils/commonServices";
import { LoadingButton } from "@mui/lab";
import { updateTeamState } from "../../../redux/teamSlice";
import CustomInput from "../../eventcreation/components/CustomInput";
import CustomAutocomplete from "../../eventcreation/components/CustomAutoComplete";
import CustomButton from "../../../components/CustomButton";
import MembersList from "./MembersList";
import { getErrorMsg } from "../../../utils/validator";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate } from "react-router-dom";
// import { customTheme as theme } from "../../../theme/customTheme";
import { addOrganisationMember } from "../../dashboard/actions";
import { getNamesFromIds, getRoleNamesFromIds } from "../../../commonactions/actions";
import { addTeamMembers } from "../actions";
import useCustomTheme from "../../../theme/useCustomTheme";




const useStyles = makeStyles((theme) => ({

  expanded: {
    width:'60%'
  }
}));



const InviteMembersPopup = (props) => {
    const {  options} = props
   
    const dispatch = useDispatch()
    const [searchTerm, setSearchTerm] = useState('');
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const [userValidationFlag, setUserValidationFlag] = useState(false);
    const [roleValidationFlag, setRoleValidationFlag] = useState(false);
    const [inviteButtonState, setInviteButtonState] = useState('Add')
    

    // const [testmembers, setTestmembers] = useState(teamsReducer.organization_members)
    const [members, setMembers] = useState(teamsReducer?.selected_team_members?.users)
    // const [testmembers, setTestmembers] = useState(members)
   
    const [searchedArray, setSearchedArray] = useState(members)
    const colors = ['red', 'pink', 'black'];

    const initialValue = {
      team_id: '',
      user_id:'',
      role_id:""      
    }

    const [pageData, setPageData] = useState(initialValue)

    const isButtonDisabled = pageData.email == '' || pageData.role_id == '' 
    const location = useLocation()
    const navigate = useNavigate()
    const [theme ] = useCustomTheme()

    const isOrganisationScope = location.pathname == '/dashboard'
    const isTeamScope =  location.pathname == '/dashboard/teams'

  
    const remainingMembers =  teamsReducer.organization_members.filter(
      (member) => !teamsReducer.selected_team_members?.users?.find((teamMember) => teamMember.id === member.id)
    );

  

    // useEffect(()=>{
    //   setTestmembers(teamsReducer.organization_members)
    // },[teamsReducer.organization_members])

       // const remainingMembers =  teamsReducer.organization_members.filter(
    //   (member) => !teamsReducer.selected_team?.team_members.find((teamMember) => teamMember.id === member.id)
    // );

    
    useEffect(()=>{
      setSearchedArray(teamsReducer?.selected_team_members?.users)
    },[teamsReducer?.selected_team_members?.users])

    
  
    const inviteClickHandler = () => {
      setPageData((last) => {
        return { ...last, team_id: teamsReducer?.selected_team?.id};
     });
      setUserValidationFlag(true)
      setRoleValidationFlag(true)
     
      afterValidate(sendInvite)
    }


    const sendInvite = () =>{
     
      const payload ={
        ...pageData,
        team_id: teamsReducer?.selected_team?.id
      }
      addTeamMembers(payload , dispatch, navigate, {commonReducer})
       
      
      // console.log({pageData})
      setInviteButtonState("Added!")
      setTimeout(() => {
        setInviteButtonState('Add')
        setUserValidationFlag(false)
        setRoleValidationFlag(false)
        setPageData(initialValue)
      }, 1500)

    }

    const handleClose = () => {
      !teamsReducer.is_loading && dispatch(updateTeamState({invite_team_members_popup : false}))      
    };

  

  const handleAutocompleteChange = (event, value) => {
    // console.log({value})
    setPageData((last) => {
      return { ...last, role_id: value.id };
  });
  }; 

  const handleSearch = (e) => {
    // const searchedInput = e.target.value.toLowerCase().trim();
    // setSearchTerm(searchedInput);

    const searchedInput = e.target.value.toLowerCase();
    if (!searchedInput.startsWith(' ')) {
      setSearchTerm(searchedInput);
    }

    const updatedFiles = [...members];

    const results = updatedFiles?.filter(item =>
      item.name?.toLowerCase().includes(searchedInput) ||
      item.email?.toLowerCase().includes(searchedInput)||
      item.role?.name?.toLowerCase().includes(searchedInput)
    );
    setSearchedArray(results);
  };

    return (
        <CustomAlert 
          open={teamsReducer.invite_team_members_popup} 
          handleClose={handleClose} 
          height={{xs:'420px', md:'75%',lg:'70%',xl:'600px'}}
          width={{md:'65%',lg:'65%', xl:'1400px'}}
          rightComponent={
          <Box sx={{display:'flex', flexDirection:'column', paddingX:{xs:'5px',sm:'8px',md:'1rem', lg:'1.2rem', xl:'2rem'},height:'100%'}}>
            <Box sx={{height: '100%'}} className= 'flex col j-center a-center' style={{alignItems:'flex-start'}}> 
            <Typography sx={{fontSize:{ xs: 8.5, md: 9.5,lg:'12px', xl: 16 }, fontWeight:600, fontFamily:'Rubik', color:'#000'}}>Team Leads</Typography>
            <Box component='ul' pl={1} style={{listStyleType: 'disc'}} mt={0} >
                <Typography component='li' sx={{fontSize:{ xs: 7.5, md: 8.5,lg:'11px', xl: 15 }, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Add or remove team members</Typography>
                <Typography component='li' sx={{fontSize:{ xs: 7.5, md: 8.5,lg:'11px', xl: 15 }, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Change team member roles</Typography>
                <Typography component='li' sx={{fontSize:{ xs: 7.5, md: 8.5,lg:'11px', xl: 15 }, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Create and manage projects</Typography>
                <Typography component='li' sx={{fontSize:{ xs: 7.5, md: 8.5,lg:'11px', xl: 15 }, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Have full access to all projects of their team</Typography>
              </Box>
              <Typography  sx={{fontSize:{ xs: 8.5, md: 9.5,lg:'12px', xl: 16 }, fontWeight:600, textAlign:'justify', fontFamily:'Rubik', color:'#000'}}>Team Members</Typography>
              <Box component='ul' pl={1} style={{listStyleType: 'disc'}} mt={0}>
                <Typography component='li' sx={{fontSize:{ xs: 7.5, md: 8.5,lg:'11px', xl: 15 }, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>View list of other team members</Typography>
                <Typography component='li' sx={{fontSize:{ xs: 7.5, md: 8.5,lg:'11px', xl: 15 }, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>View list of projects they are associated with</Typography>
                <Typography component='li' sx={{fontSize:{ xs: 7.5, md: 8.5,lg:'11px', xl: 15 }, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>View their team name on the main dashboard</Typography>
              </Box>
            </Box>
          </Box>}
          >       
            <Box sx={{display:'flex', flexDirection:'column', height:'100%'}} px={4} pt={3} pb={2}>
              <Box flexGrow={1} pt={1} >
                  <Typography mb={1} sx={{fontWeight:600, fontFamily:'Rubik', fontSize:{xs:'16px',sm:'16px',md:'18px',lg:'20px',xl:'27px'}, color:'#000'}}>Invite with email</Typography>
                  <Box gap={2} style={{display:'flex'}} mb={3}>
                            <Box style={{width:'40%'}}>

                            {/* {location.pathname == '/dashboard/teams' ? ( */}
                              <CustomAutocomplete
                                  onFocus={()=>setUserValidationFlag(false)}
                                  onBlur={()=>setUserValidationFlag(true)}
                                  options={remainingMembers}
                                  placeholder='Select...'
                                  disabled = {teamsReducer.is_loading}
                                  required
                                  errorFlag={
                                  userValidationFlag &&
                                  getErrorMsg("member", pageData?.user_id) != ""
                                  }
                                  errorMsg={getErrorMsg("member", pageData?.user_id)}
                                  onChange={(event, value)=>{
                                    setPageData((last) => {
                                        return { ...last, user_id: value.id };
                                    });
                                  }}
                                  value={getNamesFromIds(pageData?.user_id, remainingMembers)}
                                  getOptionLabel={(option) =>
                                  Object.keys(option).length > 0 ? option.name : ""
                                  }
                      
                                  renderOption={(props, option, { selected , index}) => (
                                    <li {...props} >       
                                        <Avatar
                                          sx={{
                                          borderRadius: '5px',
                                          backgroundColor: colors[index % colors.length],
                                          color: 'white',
                                          width: { xs: '18px', sm: '20px', md: '22px', lg: '23.5px', xl: '35px' },
                                          height: { xs: '18px', sm: '20px', md: '22px', lg: '23.5px', xl: '35px' },
                                          paddingRight: 0,
                                          marginRight: 0,
                                          fontSize: { xs: '7px', md: '8px', lg: '8px', xl: '12px' },
                                          textTransform: 'uppercase',
                                          fontFamily: 'Rubik',
                                          fontWeight:600,
                                          mr:2
                                          }}
                                        >
                                          {getInitials(option.name)}
                                        </Avatar>
                                        <Box sx={{'& span': {color: theme.palette.mode === 'light' ? '#586069' : '#8b949e',},}}>{option.name}</Box>
                                    </li>
                                )}
                              />
                            {/* ):(
                              <CustomInput
                                onFocus={()=>setEmailValidationFlag(false)}
                                onBlur={()=>setEmailValidationFlag(true)}
                                required
                                errorFlag={
                                  emailValidationFlag &&
                                  getErrorMsg("email", pageData?.email) != ""
                                }
                                errorMsg={getErrorMsg("email", pageData?.email)}
                                type="email"
                                max={40}
                                placeholder="Add members by email..."
                                onChange={(event) => {
                                  setInput(
                                    pageData?.email != ""
                                    ? event.target.value
                                    : event.target.value.trim(),
                                    "email",
                                    pageData,
                                    setPageData
                                  );
                                }}
                                value={pageData?.email}
                              />
                            )}
                     */}
                            </Box>
                            <Box style={{width:'25%'}}>         
                              <CustomAutocomplete
                                options={options}
                                placeholder='Set as...'
                                onFocus={() => {
                                  setUserValidationFlag(true)
                                  setRoleValidationFlag(false)
                                }}
                                disabled = {teamsReducer.is_loading}
                                onBlur={() => setRoleValidationFlag(true)}
                                required
                                errorFlag= {roleValidationFlag && getErrorMsg("role_type", pageData?.role_id) != ""}
                                errorMsg= {getErrorMsg("role_type", pageData?.role_id)}
                                onChange={handleAutocompleteChange}
                                value={getRoleNamesFromIds(pageData?.role_id, options)}
                                getOptionLabel={(option) =>
                                Object.keys(option).length > 0 ? option.name : ""
                                }
                                />
                            </Box>
                            <Box>
                              <CustomButton color='secondary' variant='contained'  btnText={inviteButtonState} disabled = {teamsReducer.is_loading} type='button' onClick={inviteClickHandler}  sx={{
                              //  backgroundColor:theme.palette.secondary.main, 
                               borderRadius:'5px', border:'none', fontSize: {xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, padding:'10px', width:'6.1rem', fontWeight:600, textTransform:'none', height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"},fontFamily:'Rubik' }}/>
       
                            </Box>
                  </Box>
                  <Box className='flex col' gap={1.5} >
                    <Box className='flex j-between a-center' style={{width:'80%'}}>
                      <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'16px',sm:'16px',md:'18px',lg:'20px',xl:'27px'}}}>Members ({members?.length})</Typography>
                      <Box id="search" className='flex j-end'>
                        <Input
                          id="search-input"
                        value={searchTerm}
                        disabled = {teamsReducer.is_loading}
                        inputProps={{ maxLength: 50 }}
                        onChange={handleSearch}
                        sx={{
                          //  minWidth: '160px',
                            // borderBottom: 1,
                            borderColor: "transparent",
                            input: {
                                fontSize: { xs: '12px', md: '12px', lg: '13px', xl: '16px' },
                                fontWeight: 400,
                                color: "#000000",
                              
                            },
                           
                            justifySelf:'flex-end',
                            width:'60%', 
                            transition: 'width 0.3s ease',
                          
                            // mr:5
                        }}
                        placeholder="Search"
                        startAdornment={
                            <IconButton sx={{paddingBottom:0.5, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'15px',xl:'20px'}}, paddingRight:2}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                    </Box>
                    </Box>
                    <Box sx={{height:'22vh', overflowY:'auto',}}>

                      {searchedArray?.length > 0 ? searchedArray?.map((member, index) => {
                        return  <MembersList  member={member} index={index} testmembers={searchedArray} setTestmembers={setSearchedArray} roleOptions={options}/>
                      }): 
                       <Box className= 'flex col j-center a-center' sx={{overflowY: "initial", whiteSpace: 'normal'}} height='100%' width='100%'>
                          <Typography sx={{fontSize: 20, color: '#878887', fontWeight: 300, textAlign: 'center', fontFamily:'Rubik'}} >No results found.
                          </Typography>
                        </Box>
                      }    
                    </Box>
                  </Box>
  
              </Box>

              {/* <Box sx={{display:'flex', flexDirection:'column', justifyContent:'flex-end', alignItems:'end'}}>
               <Box pr={1.5}>

               { requestStatus == 'loading'  ? <LoadingButton
                  
                    sx={{
                        '& .MuiLoadingButton-loadingIndicator': {
                            color: theme.palette.primary.main,
                        },
                        height: {xs:'36px',sm:'40px',md:'45px', lg:'51px',xl:'75px'},
                       minWidth: {xs:'36px !important',sm:'40px !important',md:'45px !important', lg:'51px !important',xl:'75px !important'},
                        backgroundColor: '#08231B'
                    }}
                    loading={requestStatus == 'loading'}
                    variant="outlined"
                    disabled
                    >
                   
               </LoadingButton> :
               <CheckIcon onClick= {submitRequestClickHandler}  sx={{fontSize:{xs:'40px',sm:'44px',md:'50px', lg:'56px',xl:'82px'}, cursor: 'pointer'}}/>
               }
                 
                </Box>
              <Box>    
                <Button 
                variant="text"
                onClick={handleClose}
                 sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'70px',sm:'70px',md:'80px',lg:'90px',xl:'120px'}, fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
                >
                Or Go Back
               </Button>
              </Box>
            </Box> */}
          </Box>
       
        </CustomAlert>
      )
}

export default InviteMembersPopup